// extracted by mini-css-extract-plugin
export default {"container":"ConfirmModal_container__q6apf","buttonWrapper":"ConfirmModal_buttonWrapper__jj5iI","title":"ConfirmModal_title__IF4E1","icon":"ConfirmModal_icon__jsdg2"};